import _toConsumableArray from "E:/Jweb/\u7ED3\u8BFE\u4F5C\u4E1A/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { getHotArticleList } from "../api/article";
import { reactive } from "@vue/reactivity";
import { defaultThumbnail, useDefaultThumbnail } from "../utils/thumbnail";
export default {
  name: "KilaKilaHotArticleCard",
  setup: function setup() {
    var hotArticles = reactive([]);
    getHotArticleList().then(function (data) {
      data.forEach(function (article) {
        article.createTime = article.createTime.split(" ")[0];
        article.thumbnail = article.thumbnail || defaultThumbnail;
      });
      hotArticles.push.apply(hotArticles, _toConsumableArray(data));
    });
    return {
      hotArticles: hotArticles,
      useDefaultThumbnail: useDefaultThumbnail
    };
  }
};